<template>
	<div class="animated fadeIn">
		<b-row class="justify-content-center">
			<b-col sm="12" md="8" lg="4">
				<b-card>
					<div slot="header">
						<strong>Cambiar Contraseña</strong>
					</div>
					<b-card-body>
						<b-alert
							variant="success"
							:show="dismissCountDown"
							fade
							dismissible
							class="text-center"
							@dismissed="dismissCountDown=0"
							@dismiss-count-down="countDownChanged">
							<strong>{{sucessMessage}}</strong>
							<b-progress
								variant="success"
								:max="dismissSecs"
								:value="dismissCountDown"
								height="4px"
							></b-progress>
						</b-alert>
						<b-form @submit="changePassword">
							<label class="m-0"><strong class="text-muted">Contraseña Actual:</strong></label>
							<b-input-group class="mb-3">
								<b-input-group-prepend>
									<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
								</b-input-group-prepend>
								<b-form-input
									type="password"
									class="form-control"
									placeholder="Contraseña Actual"
									autocomplete="current-password"
									v-model="changeUserPassword.password"
									required/>
							</b-input-group>

							<label class="m-0"><strong class="text-muted">Nueva Contraseña:</strong></label>
							<b-input-group class="mb-3">
								<b-input-group-prepend>
									<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
								</b-input-group-prepend>
								<b-form-input
									type="password"
									class="form-control"
									placeholder="Nueva Contraseña"
									autocomplete="current-password"
									v-model="changeUserPassword.newPassword"
									required/>
							</b-input-group>

							<label class="m-0"><strong class="text-muted">Confirmación de Contraseña:</strong></label>
							<b-input-group class="mb-4">
								<b-input-group-prepend>
									<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
								</b-input-group-prepend>
								<b-form-input
									type="password" class="form-control"
									placeholder="Confirmación de Contraseña"
									autocomplete="current-password"
									v-model="changeUserPassword.passwordConfirm"
									required/>
							</b-input-group>
							<b-row class="justify-content-end">
								<b-col v-if="errorMessage" cols="12" class="mb-3">
									<h6 class="text-danger">{{errorMessage}}</h6>
								</b-col>
								<b-col md="12" lg="12" class="d-flex justify-content-end">
									<i v-if="loading" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
									<span class="sr-only">Loading...</span>
									<b-button type="submit" v-if="!loading" variant="primary" class="btn-block">
										Cambiar Contraseña
									</b-button>
								</b-col>
							</b-row>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	export default {
		name: "ChangePasswordForm",
		data: function () {
			return {
				loading: false,
				errorMessage: '',
				sucessMessage: '',
				dismissSecs: 5,
				dismissCountDown: 0,
				changeUserPassword: {
					password: '',
					newPassword: '',
					passwordConfirm: ''
				}
			}
		},
		methods: {
			changePassword(evt) {
				evt.preventDefault();
				this.loading = true;

				this.errorMessage = '';

				this.$store.dispatch('changePassword', this.changeUserPassword)
					.then((resp) => {
						this.sucessMessage = resp;
						this.dismissCountDown = this.dismissSecs;
						this.changeUserPassword.password = '';
						this.changeUserPassword.newPassword = '';
						this.changeUserPassword.passwordConfirm = '';
					})
					.catch((err) => {
						this.errorMessage = err.data.Message;
					})
					.finally(() => {
						this.loading = false;
					})
			},
			countDownChanged(dismissCountDown) {
				this.dismissCountDown = dismissCountDown
			},
		}
	}
</script>

<style scoped>

</style>
